export const printLocaleString = (date: string | Date, withoutTime?: boolean) => {
  if (!date) {
    return '';
  }

  return new Date(date).toLocaleString('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: withoutTime ? undefined : '2-digit',
    minute: withoutTime ? undefined : '2-digit',
  });
};
